var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"carousel__item-text san-richtext",class:{ 'carousel__item-text--active': _vm.isActive },domProps:{"innerHTML":_vm._s(_vm.item.text || '')}})}
var staticRenderFns = []

export { render, staticRenderFns }